var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 139 55",
    style: {
      enableBackground: "new 0 0 139 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{opacity:0.6;fill:url(#SVGID_00000031171351209385284330000010173365689791060150_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.5367,
    y1: 2.5452,
    x2: 112.5367,
    y2: 57.5533,
    gradientTransform: "matrix(1 0 0 -1 0 55.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01016061,
    style: {
      stopColor: "#FFEADB",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1905,
    style: {
      stopColor: "#F9DBDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3361,
    style: {
      stopColor: "#ECB9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    style: {
      stopColor: "#D481F5",
      stopOpacity: 0.862
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    style: {
      stopColor: "#DE9DF7",
      stopOpacity: 0.625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#EDCAFB",
      stopOpacity: 0.3177
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1,2.4c0,0-1,41.7,5.2,48.3s24.7,5.6,36.8-2.4C140.2,40.4,139,11,139,11S128.1-1.5,109.6,0.2 C91,1.9,86.1,2.4,86.1,2.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086673914259071351960000010283292111721375649_",
    gradientUnits: "userSpaceOnUse",
    x1: -242.7364,
    y1: 0.8409,
    x2: -242.7364,
    y2: 55.8489,
    gradientTransform: "matrix(-1 0 0 -1 -216.2731 55.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01016061,
    style: {
      stopColor: "#FFEADB",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1905,
    style: {
      stopColor: "#F9DBDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3361,
    style: {
      stopColor: "#ECB9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    style: {
      stopColor: "#D481F5",
      stopOpacity: 0.862
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    style: {
      stopColor: "#DE9DF7",
      stopOpacity: 0.625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8694,
    style: {
      stopColor: "#EDCAFB",
      stopOpacity: 0.3177
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000086673914259071351960000010283292111721375649_)",
      enableBackground: "new"
    },
    d: " M52.9,2.4c0,0,1,41.7-5.2,48.3S23,56.3,10.9,48.3C-1.2,40.4,0,11,0,11S10.8-1.5,29.4,0.2S52.9,2.4,52.9,2.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowEyes);
export default __webpack_public_path__ + "static/media/ShadowEyes.d4d08d551ba966962e14dd124dfe1011.svg";
export { ForwardRef as ReactComponent };